import { useState } from "react";
import api from "../../../../api";
import RightArrowExtendedIconSVG from "../../../SharedComponents/assets/icons/svg/RightArrowExtendedIconSVG";
import ThumbDownSVG from "../../assets/icons/svg/ThumbDownSVG";
import ThumbUpSVG from "../../assets/icons/svg/ThumbUpSVG";


const RatePage = ({ onBack, partRequestId, userIdBuyer, userFirstName, userLastName }) => {

    const [formData, setFormData] = useState({
        comment: "",
        rating: "",
    });

    const handleSubmit = async () => {
        try {
            await api.post("/partrequestreview", {
                rating: Number(formData.rating),
                comment: formData.comment,
                part_request_id: partRequestId,
                useridbuyer: userIdBuyer,
            });
        } catch (err) {
            console.log(err);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    return (
        <div style={styles.modalBackdrop}>
            <div style={styles.content}>
                <h3 style={styles.title}>Zahtev realizovan - oceni saradnju</h3>
                <div>
                    <p>Hvala što koristiš SmartPart sistem!</p>
                    <p>Pomozi nam da budemo još bolji u našoj usluzi posredovanja</p>
                </div>
                <div>
                    <p>Oceni saradnju sa kupcem {userFirstName} {userLastName} za ovu ponudu</p>

                    <div style={styles.radioGroup}>
                        <div style={styles.radioOption}>
                            <input
                                type="radio"
                                name="rating"
                                value="1"
                                checked={formData.rating === "1"}
                                onChange={handleInputChange}
                                style={styles.input}
                            />
                            <label style={styles.label}><ThumbUpSVG /> Zadovoljavajuće</label>
                        </div>
                        <div style={styles.radioOption}>
                            <input
                                type="radio"
                                name="rating"
                                value="2"
                                checked={formData.rating === "2"}
                                onChange={handleInputChange}
                                style={styles.input}
                            />
                            <label style={styles.label}><ThumbDownSVG />Nezadovoljavajuće</label>
                        </div>
                    </div>
                </div>
                <textarea
                    style={styles.inputBox}
                    name="comment"
                    placeholder="Upiši komentar o saradnji"
                    value={formData.comment}
                    onChange={handleInputChange}
                />
                <div style={styles.buttonGroup}>
                    <button
                        style={styles.backButton}
                        onClick={onBack}
                    >
                        Odustani
                    </button>
                    <button
                        style={styles.submitButton}
                        onClick={handleSubmit}
                    >
                        Potvrdi ocenu <RightArrowExtendedIconSVG style={styles.arrowIcon} />
                    </button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    modalBackdrop: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(249, 250, 251, 1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000
    },
    content: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        padding: "30px",
        width: "90%",
        maxWidth: "650px",
        maxHeight: "90vh",
        overflowY: "auto",
        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "20px"
    },
    title: {
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "24px",
        fontWeight: "600"
    },
    radioGroup: {
        paddingRight: "35px",
        display: "flex",
        gap: "20px",
        alignItems: "center",
        paddingLeft: "5px",
    },
    radioOption: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
    },
    inputBox: {
        padding: "16px",
        fontSize: "14px",
        lineHeight: "1.5",
        width: "74%",
        height: "200px",
        boxSizing: "border-box",
        border: "1px solid #ccc",
        borderRadius: "4px",
        resize: "none",
    },
    input: {
        scale: "140%"
    },
    label: {
        fontSize: "18px",
        color: "black",
        paddingTop: "8px",
        display: "flex",
        alignItems: "flex-start"
    },
    buttonGroup: {
        display: "flex",
        justifyContent: "space-between",
        gap: "20px"
    },
    backButton: {
        backgroundColor: "white",
        fontSize: "16px",
        fontWeight: "bold",
        color: "rgba(91, 33, 182, 1)",
        border: "none",
        cursor: "pointer",
        transition: "background-color 0.2s"
    },
    submitButton: {
        padding: "15px",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: "#000",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        transition: "background-color 0.2s"
    },
    arrowIcon: {
        width: "20px",
        height: "20px"
    },

}


export default RatePage